import React, { FC } from 'react'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import sadBoyImage from './assets/sadBoyImage.png'
import { IEmptyListPlaceholderProps } from './types'
import { Container, Image } from './styles'

const EmptyListPlaceholder: FC<IEmptyListPlaceholderProps> = (props) => {
  const { title, linkText, link, onClick } = props

  return (
    <Container>
      <Spacing spacing='uxlarge' />

      <Text textAlign='center' fontSize='h3' lineHeight='h3'>
        {title}
      </Text>

      {linkText && (
        <a
          href={link}
          style={{
            cursor: 'pointer',
          }}
        >
          <Text
            onClick={onClick}
            textAlign='center'
            fontSize='h3'
            lineHeight='h3'
            color='blue'
          >
            {linkText}
          </Text>
        </a>
      )}

      <Spacing spacing='large' />

      <Image src={sadBoyImage} alt={title} />
    </Container>
  )
}

export default EmptyListPlaceholder
